// Shared Google Maps loader configuration.
// All map instances MUST use the same id + libraries so the
// @react-google-maps/api loader is initialized exactly once. Mismatched
// options (or multiple <LoadScript> tags) cause "google is not defined".
export const GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "AIzaSyB6HUj_uw4KoaBogJFTbP1_RdO7gYWwfqE";

// Must be a stable, module-level reference to avoid reloading the script.
export const GOOGLE_MAPS_LIBRARIES = [];

export const GOOGLE_MAPS_LOADER_ID = "google-map-script";

export const GOOGLE_MAPS_LOADER_OPTIONS = {
  id: GOOGLE_MAPS_LOADER_ID,
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  libraries: GOOGLE_MAPS_LIBRARIES,
};
